import { Link } from 'react-router-dom';
import { Server, Plus } from 'lucide-react';
import { useSshHosts } from '../hooks/useSshHosts';
import SshHostCard from '../components/SshHostCard';

export default function SshHosts() {
  const { data: hosts, isLoading } = useSshHosts();

  const connectedCount = (hosts ?? []).filter(
    (h) => h.status === 'connected',
  ).length;

  return (
    <div className="p-8">
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">SSH Hosts</h1>
          <p className="mt-1 text-sm text-slate-500">
            {hosts && hosts.length > 0
              ? `${hosts.length} host${hosts.length !== 1 ? 's' : ''} configured, ${connectedCount} connected`
              : 'Configure SSH hosts for remote Claude Code execution'}
          </p>
        </div>
        <Link
          to="/ssh-hosts/new"
          className="flex items-center gap-2 rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-slate-800"
        >
          <Plus className="h-4 w-4" />
          Add SSH Host
        </Link>
      </div>

      {isLoading ? (
        <div className="text-sm text-slate-400">Loading SSH hosts...</div>
      ) : hosts && hosts.length > 0 ? (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {hosts.map((host) => (
            <SshHostCard key={host.id} host={host} />
          ))}
        </div>
      ) : (
        <div className="rounded-xl border border-dashed border-slate-300 p-12 text-center">
          <Server className="mx-auto mb-3 h-10 w-10 text-slate-300" />
          <p className="text-sm text-slate-500">No SSH hosts configured yet.</p>
          <p className="mt-1 text-xs text-slate-400">
            Add an SSH host to run Claude Code instances on remote machines via
            SSH.
          </p>
          <Link
            to="/ssh-hosts/new"
            className="mt-4 inline-flex items-center gap-2 rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-slate-800"
          >
            <Plus className="h-4 w-4" />
            Add SSH Host
          </Link>
        </div>
      )}
    </div>
  );
}
